import { IconButton } from '@chakra-ui/react'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'

import chakraTokenToVar from '@/utils/chakraTokenToVar'
import { noOp } from '@/utils/helpers'

import Icon from '@/components/UI/Icon/Icon'

export default function IconButtonAction({
  faIcon,
  label,
  onClick = noOp,
  isDisabled = false,
}: {
  faIcon: IconDefinition
  label: string
  onClick?: () => void
  isDisabled?: boolean
}): JSX.Element {
  return (
    <IconButton
      aria-label={label}
      variant="icon"
      color="primary.contrast"
      minWidth="unset"
      backgroundColor="primary.solid"
      border="2px solid transparent"
      borderRadius="8px"
      px="12px"
      _hover={{ cursor: 'pointer', border: `2px solid ${chakraTokenToVar('gray.emphasized')}` }}
      _active={{ cursor: 'pointer', border: `2px solid ${chakraTokenToVar('gray.focusRing')}` }}
      icon={<Icon faIcon={faIcon} size="md" />}
      onClick={onClick}
      isDisabled={isDisabled}
    />
  )
}
